import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';

@Injectable({
  providedIn: 'root'
})
export class LoggedInUserService {
  private currentUserSubject = new BehaviorSubject<ILoggedInUser | null>(null);
  public currentUser$: Observable<ILoggedInUser | null> = this.currentUserSubject.asObservable();

  constructor() {}

  setCurrentUser(data: ILoggedInUser): void {
    this.currentUserSubject.next(data);
  }
}